<section class="input-form">
  <div class="input-form__heading">{{DescriptionData}} @if (starIcon) {
    <span
    class="spmred">{{starIcon}}</span>
  }</div>
  <textarea class="input-form__area" [readonly]="readonly" [formControl]="control" [maxlength]="500" placeholder={{placeholder}}></textarea>
</section>